import { render, staticRenderFns } from "./medkitlogProofAction.vue?vue&type=template&id=30473576"
import script from "./medkitlogProofAction.vue?vue&type=script&lang=js"
export * from "./medkitlogProofAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports